import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"

import { DispatchProps, mapDispatchToProps } from "../actions"
import {
    AttachmentField,
    getCustomFieldAttachments,
    getDetailPageAttachmentField,
} from "../selectors"

import InlineAttachment from "./InlineAttachment"
import { Labels } from "../../../util/Translations"
import { IAttachment, IInlineAttachments, ILightbox } from "../index"

export interface OwnProps {
    canAddAttachments: boolean
    canDeleteAttachments: boolean
    customFieldDefinitionId: string
    customFieldName: string
    isPrintView: boolean
    itemId: number
}

interface StateProps extends IInlineAttachments, AttachmentField {
    attachmentsWithoutPagination: IAttachment[]
    lightbox: ILightbox
}

type Props = OwnProps & StateProps & DispatchProps

export class DetailPageInlineAttachment extends React.PureComponent<Props> {
    componentDidMount(): void {
        this.requestAttachments()
    }

    render(): JSX.Element {
        const {
            canAddAttachments,
            canDeleteAttachments,
            customFieldName,
            attachments,
            showAllDocuments,
            isPrintView,
            attachmentLoadCounter,
            attachmentsWithoutPagination,
            customFieldDefinitionId,
            lightbox,
        } = this.props

        return (
            <InlineAttachment
                wrapperClasses="tw-p-2 tw-w-full sm:tw-w-1/2 md:tw-w-1/3 lg:tw-w-1/6"
                canAddAttachments={!isPrintView && canAddAttachments}
                canEditAttachments={!isPrintView && canDeleteAttachments}
                fieldName={customFieldName}
                customFieldDefinitionId={customFieldDefinitionId}
                attachments={attachments}
                showAllDocuments={showAllDocuments || isPrintView}
                onDeleteAttachment={this.onDeleteAttachment}
                onAddAttachment={this.onAddAttachment}
                loadMoreAttachments={this.loadMoreAttachments}
                onAttachmentLoad={this.onAttachmentLoad}
                onUpdateAttachmentDescription={
                    this.onUpdateAttachmentDescription
                }
                showLightbox={this.showLightbox}
                hideLightbox={this.hideLightbox}
                changeAttachmentInLightbox={this.changeAttachmentInLightbox}
                lightbox={lightbox}
                attachmentLoadCounter={attachmentLoadCounter}
                maxInitialCards={18}
                attachmentsWithoutPagination={attachmentsWithoutPagination}
            />
        )
    }

    onAddAttachment = (request: UploadRequest): void => {
        const { customFieldDefinitionId, itemId, requestAddAttachment } =
            this.props
        const formData = new FormData()
        formData.append(request.filename, request.file)
        requestAddAttachment(itemId, customFieldDefinitionId, formData)
    }

    onDeleteAttachment = (attachmentId: number): void => {
        const { customFieldDefinitionId, itemId, requestDeleteAttachment } =
            this.props

        const { DeleteThisAttachment } = Labels
        if (confirm(DeleteThisAttachment)) {
            requestDeleteAttachment(
                itemId,
                customFieldDefinitionId,
                attachmentId,
            )
        }
    }

    onUpdateAttachmentDescription = (key: number, value: string): void => {
        const { itemId, customFieldDefinitionId, updateAttachmentDescription } =
            this.props

        updateAttachmentDescription(key, value, itemId, customFieldDefinitionId)
    }

    requestAttachments = (): void => {
        const { customFieldDefinitionId, itemId, requestAttachments } =
            this.props
        requestAttachments(itemId, customFieldDefinitionId)
    }

    loadMoreAttachments = (): void => {
        const { customFieldDefinitionId, loadMoreAttachments } = this.props
        loadMoreAttachments(customFieldDefinitionId)
    }

    onAttachmentLoad = (): void => {
        const { customFieldDefinitionId, attachmentLoaded } = this.props
        attachmentLoaded(customFieldDefinitionId)
    }

    showLightbox = (lightboxStartingIndex: number): void => {
        const { customFieldDefinitionId, updateLightboxVisibility } = this.props
        updateLightboxVisibility(
            customFieldDefinitionId,
            true,
            lightboxStartingIndex,
        )
    }

    hideLightbox = (): void => {
        const { customFieldDefinitionId, updateLightboxVisibility } = this.props
        updateLightboxVisibility(customFieldDefinitionId, false)
    }

    changeAttachmentInLightbox = (diff: number): void => {
        const { customFieldDefinitionId, increaseLightboxCurrentIndex } =
            this.props
        increaseLightboxCurrentIndex(customFieldDefinitionId, diff)
    }
}

const mapStateToProps = (state: GlobalState, props: OwnProps): StateProps => ({
    ...state.inlineAttachments,
    ...getDetailPageAttachmentField(state.inlineAttachments, props),
    attachmentsWithoutPagination: getCustomFieldAttachments(
        state.inlineAttachments,
        props,
    ),
    lightbox: state.inlineAttachments.lightboxes[props.customFieldDefinitionId],
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DetailPageInlineAttachment)
